module.exports = __webpack_public_path__ + "img/person-tablets.f396d223.jpeg";